<template>
  <modal ref="modal" modal-id="prefill-forms-consent-modal" :show-on-mount="true" size="sm" @closed="modalClosed">
    <template #body>
      <h2>
        {{ i18n.t('member.campaigns.prefill_forms_consent_modal.title') }}
      </h2>

      <div class="py-4" v-html="i18n.t('member.campaigns.prefill_forms_consent_modal.ask_text_html')" />

      <div class="d-flex flex-column gap-3">
        <primary-button :label="i18n.t('member.campaigns.prefill_forms_consent_modal.yes_button_label')" @click="allowFormsPrefilling" />
        <light-button :label="i18n.t('member.campaigns.prefill_forms_consent_modal.no_button_label')" @click="denyFormsPrefilling" />
      </div>
    </template>
  </modal>
</template>

<script>
import LightButton from '@/components/buttons/light-button'
import { mapActions } from 'vuex'
import Modal from '@/components/modal'
import PrimaryButton from '@/components/buttons/primary-button'

export default {
  components: { LightButton, Modal, PrimaryButton },

  data() {
    return {
      decidedOnConsent: false
    }
  },

  methods: {
    ...mapActions(['recordOptInForPrefillForms', 'recordOptOutForPrefillForms']),

    async allowFormsPrefilling() {
      this.decidedOnConsent = true
      await this.recordOptInForPrefillForms()
      this.$refs.modal.close()
    },

    async denyFormsPrefilling() {
      this.decidedOnConsent = true
      await this.recordOptOutForPrefillForms()
      this.$refs.modal.close()
    },

    modalClosed() {
      if (!this.decidedOnConsent) {
        this.$store.commit('cancelRequestForPrefillFormsConsent')
      }
    }
  }
}
</script>

<style scoped>
  :deep(.modal-header) {
    border-bottom: none;
  }

  :deep(.modal-body) {
    padding-top: 0;
  }
</style>
